import React, {useEffect} from 'react';
import './App.css';
import {CssBaseline} from '@material-ui/core';
import {ThemeProvider} from '@material-ui/core/styles';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import theme from "./theme";
import Header from './components/partial/Header';
import TestLayout from './components/layout/test/TestLayout';
import ResultLayout from "./components/layout/result_list/ResultLayout";
import ResultDetailLayout from "./components/layout/result_detail/ResultDetailLayout";
import MyLessons from './components/layout/learning/my_lessons/MyLessons';
import MyCourses from './components/layout/learning/my_courses/MyCourses';
import HomePage from "./components/layout/home/HomePage";
import MyTests from "./components/layout/learning/my_tests/MyTests";
import {useClearCache} from "react-clear-cache";
import ClearCache from "./components/helper/ClearCache";
import withTranslation from "./i18next/withTranslation";
import {useNetwork} from "./helpers/useNetwork";
import Alert from '@material-ui/lab/Alert';
import i18n from "i18next";
import {useSetRecoilState} from "recoil";
import {isOnlineState} from "./states/states";

function App() {

    const {loading, isLatestVersion, emptyCacheStorage} = useClearCache({
        duration: 60 * 1000,
        auto: true
    });
    const setIsOnline = useSetRecoilState(isOnlineState);
    const isOnline = useNetwork();

    // window.addEventListener("popstate", (event) => { //Bỏ logic back
    //     event.stopImmediatePropagation();
    //     window.history.back(window.history.length);
    // });

    useEffect(() => {
        setIsOnline(isOnline);
    }, [isOnline]);

    if (loading && !isLatestVersion) {
        emptyCacheStorage();
    }

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Router>
                <Header/>
                {!isOnline && <Alert severity="warning">{i18n.t('NO_NETWORK')}</Alert>}
                <Switch>
                    <Route path="/" exact>
                        <HomePage/>
                    </Route>
                    <Route path="/start">
                        <TestLayout/>
                    </Route>
                    <Route path="/result">
                        <ResultLayout/>
                    </Route>
                    <Route path="/result_detail">
                        <ResultDetailLayout/>
                    </Route>
                    <Route path="/my-courses">
                        <MyCourses/>
                    </Route>
                    <Route path="/my-lessons">
                        <MyLessons/>
                    </Route>
                    <Route path="/my-tests">
                        <MyTests/>
                    </Route>
                    <Route path="/clear-cache">
                        <ClearCache/>
                    </Route>
                </Switch>
            </Router>
        </ThemeProvider>
    );
}

export default withTranslation(App);
